import {
    Link,
    Navigate,
    useLocation,
    useNavigate,
    useNavigation,
} from "react-router-dom";
import { usePaymentsStore } from "../../../store/payments.store";
import {
    Box,
    Button,
    Card,
    CardContent,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    IconButton,
    Paper,
    Typography,
    useMediaQuery,
} from "@mui/material";
import { useOrganizationStore } from "../../../store/organization.store";
import { useLayoutEffect, useMemo, useState } from "react";
import { MetersNames } from "../../../configs/meters.config";
import {
    Invoice,
    InvoiceInfo,
    InvoicesResponse,
    MonthInvoices,
} from "../../../types/Store/PaymentsStore.types";
import { LoadingPage } from "../../../utils/components/LoadingPage";
import dayjs from "dayjs";
import { QRCodeSVG } from "qrcode.react";
import { Loading } from "../../../utils/components/Loading";
import { throwError } from "../../../hooks/useErrorHandler";
import { useAuthStore } from "../../../store/auth.store";
import { enqueueSnackbar } from "notistack";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { PaymentsMethods } from "../../../configs/payments-methods.config";

export function HistoryDetailed() {
    const location = useLocation();
    const navigate = useNavigate();
    const searchParams = new URLSearchParams(location.search);

    if (!searchParams.get("month")) return <Navigate to={"/"} />;

    const {
        payments,
        getPeriodPayments,
        getInvoicePaymentInfo,
        getRecipientInfo,
    } = usePaymentsStore();
    const { activeAccount, accounts } = useAuthStore();
    const activeAcc = accounts?.find((acc) => acc.id === activeAccount);

    const [loadingPage, setLoadingPage] = useState(false);
    const isMobile = useMediaQuery("(max-width:1100px)");
    const isSmallMobile = useMediaQuery("(max-width:700px)");

    const [paymentInfo, setPaymentInfo] = useState<MonthInvoices | null>(null);

    useLayoutEffect(() => {
        (async () => {
            try {
                setLoadingPage(true);
                // await getOrganizationInfo();
                const data = await getPeriodPayments(
                    0,
                    searchParams.get("month"),
                );
                setPaymentInfo(data?.months?.[0] ?? null);
                if (data?.months.length === 0)
                    return navigate("/admin/payments");
            } catch (error) {
            } finally {
                setLoadingPage(false);
            }
        })();
    }, []);

    const [dialogInfo, setDialogInfo] = useState<InvoiceInfo | null>();
    const [dialogInvoice, setDialogInvoice] = useState<Invoice | null>();
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogLoading, setDialogLoading] = useState(false);

    if (!paymentInfo) return <LoadingPage />;

    const handleOpenDialog = async (item: Invoice) => {
        try {
            setDialogLoading(true);
            setDialogInvoice(item);
            setDialogOpen(true);
            const invoceInfo = await getInvoicePaymentInfo(item.id);
            setDialogInfo(invoceInfo);
            setDialogLoading(false);
        } catch (error) {
            setDialogOpen(false);
            throwError(error);
        } finally {
            setDialogLoading(false);
        }
    };

    const handleCloseDialog = () => {
        setDialogInfo(undefined);
        setDialogOpen(false);
    };

    const handleDownloadReceipt = async (invoice_id: string | number) => {
        enqueueSnackbar({
            message: "Загружаем квитанцию...",
            variant: "info",
        });
        const receiptURL = await getRecipientInfo(invoice_id);
        if (receiptURL) window.open(receiptURL, "_blank");
    };

    return (
        <Box
            sx={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "space-between",
                gap: "32px",
                flexDirection: isMobile ? "column" : "row",
            }}
        >
            {isMobile && (
                <Button
                    component={Link}
                    to={"/admin/payments"}
                    variant="contained"
                    sx={{ width: "100px" }}
                >
                    Назад
                </Button>
            )}
            {/* <Paper
                sx={{
                    padding: "24px 32px",
                    maxWidth: isMobile ? "auto" : "560px",
                    width: "100%",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: isMobile
                            ? "flex-start"
                            : "space-between",
                        gap: "16px",
                        flexDirection: isMobile ? "column" : "row",
                    }}
                >
                    <Typography variant="h6">Детализация услуг</Typography>
                    <Button
                        variant="outlined"
                        sx={{
                            marginTop: isMobile ? "12px" : 0,
                            marginBottom: isMobile ? "12px" : 0,
                        }}
                    >
                        Скачать квитанцию
                    </Button>
                </Box>
                <Typography color="text.secondary">
                    {dayjs("01 " + paymentInfo.month).format("MMMM, YYYY")}
                </Typography>
                <Box>
                    <Box>
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                paddingTop: "8px",
                                paddingBottom: "8px",
                                borderBottom: "1px solid #ccc",
                            }}
                        >
                            <Typography fontWeight={"bold"}>Услуга</Typography>
                            <Typography fontWeight={"bold"}>Итого</Typography>
                        </Box>
                        {paymentInfo.invoices.map((n) => {
                            return (
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        paddingTop: "8px",
                                        paddingBottom: "8px",
                                        borderBottom: "1px solid #ccc",
                                    }}
                                    key={n.id}
                                >
                                    <Typography>
                                        {MetersNames[n.payment_type]}
                                    </Typography>
                                    <Typography>
                                        {n.amount.toFixed(2)}₽
                                    </Typography>
                                </Box>
                            );
                        })}
                    </Box>
                </Box>
            </Paper> */}
            <Grid container spacing={2} sx={{ flex: 1 }}>
                {paymentInfo.invoices.map((invoice: Invoice) => {
                    return (
                        <Grid size={{ xs: 12, sm: 12, md: 12, xl: 6 }}>
                            <Card
                                sx={{
                                    height: "100%",
                                    display: "flex", // Добавляем flex для Card
                                    flexDirection: "column", // Вертикальное направление
                                }}
                            >
                                <CardContent
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        flexGrow: 1, // Растягиваем на всю доступную высоту
                                        p: 3,
                                    }}
                                >
                                    {/* Верхняя часть с названием организации */}
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "flex-start",
                                            marginBottom: 2,
                                        }}
                                    >
                                        <Box>
                                            <Typography
                                                variant="h5"
                                                fontWeight="bold"
                                            >
                                                {
                                                    invoice.service_organization
                                                        .name
                                                }
                                            </Typography>
                                            <Typography
                                                sx={{ fontSize: 15 }}
                                                color="text.secondary"
                                            >
                                                {dayjs(invoice.end_date).format(
                                                    "MMMM YYYY",
                                                )}
                                            </Typography>
                                        </Box>

                                        <Button
                                            variant="outlined"
                                            size="small"
                                            sx={{
                                                textTransform: "none",
                                            }}
                                            onClick={() => {
                                                handleDownloadReceipt(
                                                    invoice.id,
                                                );
                                            }}
                                        >
                                            Скачать квитанцию
                                        </Button>
                                    </Box>

                                    {/* Список платежей - будет растягиваться */}
                                    <Box sx={{ flexGrow: 1 }}>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                py: 1,
                                                borderBottomWidth: 1,
                                                borderBottomStyle: "solid",
                                                borderBottomColor: "#e0e0e0",
                                            }}
                                        >
                                            <Typography
                                                variant="body2"
                                                color="text.secondary"
                                            >
                                                {
                                                    MetersNames[
                                                        invoice.payment_type
                                                    ]
                                                }
                                            </Typography>
                                            <Typography
                                                variant="body2"
                                                fontWeight="500"
                                            >
                                                {invoice.amount.toFixed(2)}₽
                                            </Typography>
                                        </Box>
                                    </Box>

                                    {/* Кнопка оплаты - всегда внизу */}
                                    <Box sx={{ mt: "auto", pt: 2 }}>
                                        <Button
                                            fullWidth
                                            variant="contained"
                                            color="success"
                                            sx={{
                                                borderRadius: 1,
                                                // py: 1.5,
                                            }}
                                            onClick={() =>
                                                handleOpenDialog(invoice)
                                            }
                                        >
                                            Оплатить ЖКУ
                                        </Button>
                                    </Box>
                                </CardContent>
                            </Card>
                        </Grid>
                    );
                })}
            </Grid>
            <Dialog open={dialogOpen}>
                <DialogTitle>Оплата</DialogTitle>
                {dialogLoading ? (
                    <Box
                        sx={{
                            height: "200px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <Loading />
                    </Box>
                ) : (
                    <>
                        <DialogContent>
                            {isSmallMobile ? (
                                <>
                                    <Typography>
                                        Оплатите ЖКУ компании{" "}
                                        {
                                            dialogInvoice?.service_organization
                                                .name
                                        }{" "}
                                        в размере{" "}
                                        {dialogInvoice?.amount.toFixed(2)}{" "}
                                        рублей.
                                    </Typography>
                                    <Typography>
                                        Для оплаты испольуйзте инструкцию ниже:
                                    </Typography>
                                    <Typography>
                                        Cкопируйте лицевой счёт:{" "}
                                        <span style={{ color: "#777" }}>
                                            {activeAcc?.external_id}
                                        </span>
                                        <IconButton
                                            size="small"
                                            onClick={() =>
                                                navigator.clipboard
                                                    .writeText(
                                                        activeAcc?.external_id ??
                                                            "",
                                                    )
                                                    .then(() => {
                                                        enqueueSnackbar({
                                                            message:
                                                                "Текст скопирован",
                                                            variant: "success",
                                                        });
                                                    })
                                                    .catch((err) => {
                                                        enqueueSnackbar({
                                                            message:
                                                                "Текст не скопирован",
                                                            variant: "error",
                                                        });
                                                    })
                                            }
                                        >
                                            <ContentCopyIcon />
                                        </IconButton>
                                    </Typography>
                                    <Typography>
                                        Для оплаты нажмите на кнопку "Оплатить"
                                    </Typography>
                                </>
                            ) : (
                                <>
                                    <Typography>
                                        Для оплаты воспользуйтесь QR кодом:
                                    </Typography>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            marginTop: "30px",
                                        }}
                                    >
                                        {dialogInfo?.qr_data && (
                                            <QRCodeSVG
                                                value={dialogInfo.qr_data}
                                                size={256}
                                            />
                                        )}
                                    </Box>
                                </>
                            )}
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleCloseDialog}>Отмена</Button>
                            {isSmallMobile && (
                                <Button
                                    href={dialogInfo?.payment_link || ""}
                                    target="_blank"
                                >
                                    Оплатить
                                </Button>
                            )}
                        </DialogActions>
                    </>
                )}
            </Dialog>
        </Box>
    );
}
